<div class="card">
   <app-filter-container
      *ngIf="filters.length"
      [filters]="filters"
      [defaultFilterApplied]="defaultSelectedFilters"
      (appliedFilters)="loadCall($event.origin, $event.filters)"
      class="mb-2"
   ></app-filter-container>

   <!-- LOADING TABLE SKELETON -->
   <div *ngIf="loading()">
      <p-table [value]="[{}, {}, {}, {}, {}, {}, {}, {}]">
         <ng-template pTemplate="header">
            <tr>
               <th>Customer</th>
               <th>Phone Number</th>
               <th>Status</th>
               <th>Conversation Result</th>
               <th>Duration</th>
               <th>Detalles</th>
               <th>Audio Actions</th>
               <th>Created At</th>
            </tr>
         </ng-template>
         <ng-template pTemplate="body" let-row>
            <tr>
               <td><p-skeleton width="80px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="80px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
            </tr>
         </ng-template>
      </p-table>
   </div>

   <!-- DATA TABLE -->
   <p-table
      *ngIf="outboundCalls().length && !loading()"
      [value]="outboundCalls()"
      [loading]="loading()"
      [rows]="10"
      responsiveLayout="scroll"
   >
      <ng-template pTemplate="header">
         <tr>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.CUSTOMER' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.PHONE_NUMBER' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.STATUS' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.CONVERSATION_RESULT' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.DURATION' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.TRANSCRIPTION' | translate }}</th>
            <th>{{ 'DATA.MODULES.OUTBOUNDCALL.AUDIO_ACTIONS' | translate }}</th>
            <th>{{ 'DATA.MODULES.CUSTOMERS.PAGES.CUSTOMER_LIST.FORM.CALL_TIME' | translate }}</th>
         </tr>
      </ng-template>

      <ng-template pTemplate="body" let-call>
         <tr>
            <td>
               <div class="flex flex-row gap-2 align-items-center">
                  <p-button
                     [pTooltip]="'Copia external id de la llamada'"
                     (onClick)="copyExternalId(call.externalId)"
                     icon="pi pi-copy"
                     [text]="true"
                     severity="secondary"
                     outlined="false"
                  />
                  <a
                     class="underline cursor-pointer text-primary align-items-center"
                     routerLink="{{ '/customers/customer/' + call.customer.id }}"
                     [queryParamsHandling]="'preserve'"
                  >
                     {{ call.customer.name | ellipsis: 30 }}
                  </a>
               </div>
            </td>
            <td><p-chip [label]="call.phoneNumber"></p-chip></td>
            <td>
               <app-custom-tag
                  [status]="call.status.toUpperCase()"
                  [value]="'DATA.COMMON.STATUS.' + call.status | translate"
               />
            </td>
            <td>
               <ng-container *ngIf="!!call.conversationResult; else noName">
                  {{ call.conversationResult }}
               </ng-container>
               <ng-template #noName>
                  <p *ngIf="call.status == 'failed'" class="font-italic text-red-400">
                     <i class="pi pi-ban"></i> {{ call.failedReason }}
                  </p>
               </ng-template>
            </td>
            <td>
               <ng-container *ngIf="call.duration > 0; else noDuration">
                  <p-tag icon="pi pi-clock" severity="secondary" [value]="call.duration.toString() + ' s'" />
               </ng-container>
            </td>
            <ng-template #noDuration>
               <p class="font-italic text-gray-400">No hay resultados</p>
            </ng-template>
            <td>
               <ng-container *ngIf="call.duration > 0; else noTranscription">
                  <p-button
                     (click)="openAudioDialog(call)"
                     size="small"
                     severity="secondary"
                     icon="pi pi-eye"
                     [label]="'DATA.MODULES.CUSTOMERS.PAGES.ACTIVITIES.LABEL.SHOW_CALL' | translate"
                  ></p-button>
               </ng-container>
               <ng-template #noTranscription>
                  <p class="font-italic text-gray-400">No hay resultados</p>
               </ng-template>
            </td>
            <td>
               <ng-container *ngIf="call.duration > 0; else noAction">
                  <p-button
                     [icon]="
                        loadingAudioCalls[call.id]
                           ? 'pi pi-spin pi-spinner'
                           : playingCallId() === call.id
                             ? 'pi pi-pause'
                             : 'pi pi-play'
                     "
                     size="small"
                     severity="secondary"
                     [text]="playingCallId() !== call.id"
                     [label]="playingCallId() === call.id ? formatTime(currentTimeMap[call.id] || 0) : ''"
                     (click)="playCallAudio(call)"
                  ></p-button>

                  <p-button
                     [icon]="loadingDownloads[call.id] ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                     severity="secondary"
                     text="true"
                     styleClass="ml-2"
                     size="small"
                     (click)="downloadCallAudio(call)"
                  ></p-button>
               </ng-container>
               <ng-template #noAction>
                  <p *ngIf="call.status != 'failed'" class="font-italic text-gray-400">No hay resultados</p>
               </ng-template>
            </td>
            <td>{{ call.createdAt | timezoneDate: true }}</td>
         </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
         <tr>
            <td class="p-d-flex p-align-center p-justify-center" colspan="9">
               {{ 'DATA.MODULES.OPERATIONS.PAGES.OPERATION_LIST.TABLE.MORE.NO_RESULTS' | translate }}
            </td>
         </tr>
      </ng-template>
   </p-table>

   <div
      *ngIf="!loading() && this.outboundCalls().length == 0"
      class="spinner-container text-center align-content-center mt-8 h-27rem"
   >
      <div class="text-900 font-bold text-6xl mb-4">
         {{ 'DATA.MODULES.OUTBOUNDCALL.NO_DATA' | translate }}
      </div>
      <div class="text-400 font-semibold text-xl mb-4">
         {{ 'DATA.MODULES.OUTBOUNDCALL.NO_DATA_DESC' | translate }}
      </div>
   </div>

   <div class="grid gap-2 w-full mt-4">
      <div class="col text-center flex justify-content-start w-full align-items-center gap-2">
         <span class="text-500 text-sm">Resultados totales:</span>
         <span class="font-semibold text-sm text-700">{{ totalResults() }}</span>
      </div>

      <div class="col text-center flex justify-center w-full align-items-center justify-content-center gap-3">
         <!-- Extract to comp. on second use -->
         <p-button
            severity="primary"
            icon="pi pi-angle-left"
            [disabled]="loading() || currentPage() === 1"
            styleClass="p-button-text"
            (click)="loadCall(SearchOrigin.LOAD_PREV, facade.lastCriteria())"
         ></p-button>
         <p-button type="button" icon="pi pi-refresh" (onClick)="resetCalls()" styleClass="p-button-text" />
         <p-button
            severity="primary"
            type="button"
            icon="pi pi-angle-right"
            [disabled]="loading() || !hasMore()"
            styleClass="p-button-text"
            (click)="loadCall(SearchOrigin.LOAD_NEXT, facade.lastCriteria())"
         ></p-button>
      </div>

      <div class="col text-center flex justify-content-end w-full align-items-center gap-2">
         <span class="text-500 text-sm">Resultados por página:</span>
         <p-button
            *ngFor="let size of [10, 25, 50, 100]"
            label="{{ size }}"
            (onClick)="setPageSize(size)"
            [rounded]="true"
            severity="secondary"
            size="small"
            [outlined]="facade.numResultsDisplayed() !== size"
         ></p-button>
      </div>
   </div>

   <p-confirmPopup>
      <ng-template pTemplate="content" let-message>
         <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
            <i [class]="message.icon" class="text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
         </div>
      </ng-template>
   </p-confirmPopup>
</div>

<p-toast></p-toast>

<!-- TODO: Extract -->
<p-dialog
   [(visible)]="isAudioDialogVisible"
   [modal]="true"
   [dismissableMask]="true"
   [style]="{ width: '80%', height: '90%', borderRadius: '12px', overflow: 'hidden' }"
   (onHide)="onAudioDialogHide()"
>
   <ng-template pTemplate="header">
      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-phone text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            Llamada a {{ selectedCallAudio?.customer?.name }} el día {{ selectedCallAudio?.createdAt | timezoneDate }}
         </div>
      </div>
   </ng-template>

   <div class="flex flex-row gap-2">
      <app-call-transcription-dialog
         [(visible)]="isAudioDialogVisible"
         [transcription]="selectedTranscription"
         [customerName]="selectedCustomerName"
         class="transcription-panel"
      ></app-call-transcription-dialog>

      <p-divider layout="vertical"></p-divider>

      <app-outbound-call-audio-dialog
         [visible]="isAudioDialogVisible"
         [call]="selectedCallAudio"
      ></app-outbound-call-audio-dialog>
   </div>
</p-dialog>
